
import { useEffect } from "react";
import HomePageText from "../components/HomePageText";
//import ComingSoon from "../components/ComingSoon";

function Home(props) {
    useEffect(() => {
        props.funcNav(false);
        window.scrollTo(0, 0);
    }, [props]);

    return (
        <>
            <main>
                {/*
                Publish this component before website is ready to go live.
                <ComingSoon />
                */}
                {/* Publish HomePageText component when website is ready to go live.*/}
                <HomePageText />
                {/**/}
            </main>
        </>
    )

}
export default Home;